document.addEventListener("alpine:init", () => {
  Alpine.store("navigationStore", {
    on: false,
    inverted: false,
    isOverflowHidden: false,

    // Navigation visibility state
    visible: false,
    lastScrollY: 0,
    scrollThreshold: 100,
    mouseThreshold: 20, // Pixel height from top to trigger menu
    mouseTimer: null,

    open() {
      this.inverted = true;
      this.on = true;
      this.toggleOverflowHidden();
    },

    close() {
      this.inverted = false;
      this.on = false;
      this.toggleOverflowHidden();
    },

    toggleOverflowHidden() {
      this.isOverflowHidden = !this.isOverflowHidden;
      document.body.style.overflow = this.isOverflowHidden ? 'hidden' : 'auto';
    },

    toggle() {
      if (this.on) {  
        this.close();
      } else {
        this.open();
      }
    },

    checkScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      this.inverted = scrollTop > 0;
    },

    // Navigation logic
    initNavigation() {
      this.visible = false;
      this.lastScrollY = window.scrollY;

      // Scroll event for nav visibility
      window.addEventListener('scroll', () => {
        if (window.scrollY > this.scrollThreshold) {
          if (window.scrollY > this.lastScrollY) {
            this.visible = false; // Scrolling down - hide nav
          } else {
            this.visible = true; // Scrolling up - show nav
          }
        } else {
          this.visible = false; // Before threshold - hide nav
        }
        this.lastScrollY = window.scrollY;
      });

      // Mouse move event for nav visibility
      window.addEventListener('mousemove', (event) => {
        this.handleMouseMove(event);
      });

      // Optional: Hide nav when mouse leaves window (debounced)
      window.addEventListener('mouseleave', () => {
        this.visible = false;
      });
    },

    handleMouseMove(event) {
      if (event.clientY <= this.mouseThreshold && window.scrollY > this.scrollThreshold) {
        this.visible = true;
        if (this.mouseTimer) clearTimeout(this.mouseTimer);
        this.mouseTimer = setTimeout(() => {
          if (!this.isHoveringNav(event)) {
            this.visible = false;
          }
        }, 2000);
      }
    },

    isHoveringNav(event) {
      const nav = document.querySelector('nav');
      if (!nav) return false;
      const navHeight = nav.offsetHeight;
      return event.clientY <= navHeight;
    }
  });

  // Add scroll event listener to toggle `inverted` property
  window.addEventListener("scroll", () => {
    Alpine.store("navigationStore").checkScroll();
  });

  // Initialize navigation logic
  Alpine.store("navigationStore").initNavigation();
});
